import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { ApAdListResponse } from '@api/models/BannerApi/Contract/ap-ad-list-response';
import { inject, Injectable } from '@angular/core';
import { RxActionFactory, RxActions } from '@rx-angular/state/actions';
import { Observable } from 'rxjs';
import { BannerService } from '@api/services/banner.service';
import { BannerBodyModel } from '../models/banner-body.model';
import { ApAdAddResponse } from '@api/models/BannerApi/Contract/ap-ad-add-response';
import { startWithLoading } from '@core/state/operators/start-with-loading';
import { tap } from 'rxjs/operators';
import { CustomRxState } from '@core/state/rx.state';


interface IAdvertisingState {
    loading: Record<StartWithUnit, boolean>;
    banners: ApAdListResponse[];
}

interface AdvertisingActions {
    requestBanners: ApAdListResponse[];
}


@Injectable()
export class AdvertisingState extends CustomRxState<IAdvertisingState> {
    readonly #actions: RxActions<AdvertisingActions> = new RxActionFactory<AdvertisingActions>().create();
    readonly #bannerService: BannerService = inject(BannerService);

    public readonly loading$: Observable<Record<StartWithUnit, boolean>> = this.select('loading');
    public readonly banners$: Observable<ApAdListResponse[]> = this.select('banners');

    constructor() {
        super();

        this.setDefaultState();
        this.connectSelectors();

        this.requestBanners();
    }

    public requestBanners(): void {
        this.hold(
            this.#bannerService.apiBannerApAdListGet(),
            this.#actions.requestBanners,
        );
    }

    public addBanner(body: BannerBodyModel): Observable<ApAdAddResponse> {
        return this.#bannerService.apiBannerApAdAddPost({ body }).pipe(
            startWithLoading(this, StartWithUnit.AddBanner),
            tap(() => this.requestBanners()),
        );
    }

    public removeBanner(adId: number): Observable<void> {
        return this.#bannerService.apiBannerApAdDeleteDelete({ adId }).pipe(
            startWithLoading(this, StartWithUnit.RemoveBanner),
            tap(() => this.requestBanners()),
        );
    }

    private setDefaultState(): void {
        this.set({
            loading: null,
            banners: null,
        });
    }

    private connectSelectors(): void {
        this.connect('banners', this.#actions.requestBanners$);
    }
}
